import { RG_TYPE } from '../../types/rg-type.js';

/** Types of similar module-like parents that share the same children such as walls/ceilings/floors */
const ModuleLikeTypes = [RG_TYPE.Module, RG_TYPE.Corridor, RG_TYPE.Core, RG_TYPE.Entrance, RG_TYPE.Balcony];

export { ModuleLikeTypes };
//# sourceMappingURL=module-like-types.js.map
